import FooterMenuGroup from './footer-menu-group';

export default FooterMenuGroup;